const codeTypes = Object.freeze({
	DISCOUNT_CODE: 'discountCode',
	GIFT_CARD: 'giftCard',
	DISCOUNT_CODE_AND_GIFT_CARD: 'discountCodeAndGiftCard'
});

export default codeTypes;
